module.exports = __webpack_public_path__ + "img/laptop.878daf38.svg";